export function QuickStatsCard({ icon, value, label, onClick, variant = 'primary' }) {
  const variants = {
    primary: 'text-primary-600',
    success: 'text-success-600',
    neutral: 'text-neutral-600',
  }

  const Component = onClick ? 'button' : 'div'
  const clickableClass = onClick
    ? 'cursor-pointer hover:shadow-md active:scale-95 transition-all duration-200'
    : ''

  return (
    <Component
      onClick={onClick}
      className={`bg-white rounded-xl p-6 shadow-sm border border-neutral-100 ${clickableClass} w-full text-left`}
    >
      <div className="flex flex-col items-center text-center">
        <div className={`text-4xl mb-3 ${variants[variant]}`}>
          {icon}
        </div>
        <div className="text-3xl md:text-4xl font-light text-neutral-900 mb-1">
          {value}
        </div>
        <div className="text-sm text-neutral-600">
          {label}
        </div>
      </div>
    </Component>
  )
}

export function QuickStats({ followingCount, reservedCount, onFollowingClick, onReservedClick }) {
  return (
    <div className="grid grid-cols-2 gap-4 mb-6">
      <QuickStatsCard
        icon="🏠"
        value={followingCount}
        label="Following"
        onClick={onFollowingClick}
      />
      <QuickStatsCard
        icon="📋"
        value={reservedCount}
        label="Reserved"
        onClick={onReservedClick}
        variant={reservedCount > 0 ? 'success' : 'neutral'}
      />
    </div>
  )
}
